import { createContext } from 'react';

const tareaContext = createContext();

export default tareaContext;